import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { StoreLocationModel } from 'src/app/models/store-location-model';

@Component({
    selector: 'app-store-location',
    templateUrl: './store-location.component.html',
    styleUrls: ['./store-location.component.scss'],
    standalone: false
})
export class StoreLocationComponent implements OnInit {
  @Input()
  public storeLocation: StoreLocationModel;

  @Output()
  public onEditPressed = new EventEmitter();

  @Output()
  public onDeletePressed = new EventEmitter();

  @Output()
  public onActivatePressed = new EventEmitter();

  @Output()
  public onDeactivatePressed = new EventEmitter();

  private _isXLarge: boolean;
  private _isLarge: boolean
  private _isMedium: boolean;
  private _isSmall: boolean;
  private _isXSmall: boolean;

  constructor(private readonly responsive: BreakpointObserver,) {
    // Do nothing
  }

  public ngOnInit(): void {
    this.responsive.observe([Breakpoints.XSmall, Breakpoints.Small, Breakpoints.Medium, Breakpoints.Large, Breakpoints.XLarge]).subscribe(
      result => {
        const breakpoints = result.breakpoints;

        this._isXLarge = false;
        this._isLarge = false;
        this._isMedium = false;
        this._isSmall = false;
        this._isXSmall = false;

        if (breakpoints[Breakpoints.XSmall]) {
          this._isXSmall = true;
        }
        else if (breakpoints[Breakpoints.Small]) {
          this._isSmall = true;
        }
        else if (breakpoints[Breakpoints.Medium]) {
          this._isMedium = true;
        }
        else if (breakpoints[Breakpoints.Large]) {
          this._isLarge = true;
        }
        else {
          this._isXLarge = true;
        }
      }
    );
  }

  public edit(): void {
    this.onEditPressed.emit(null);
  }

  public delete(): void {
    this.onDeletePressed.emit(null);
  }

  public canShowActions(): boolean {
    const result = this.storeLocation?.isActive();
    return result;
  }

  public canShowActivationAction() : boolean {
    const result = this.storeLocation?.isArchived();
    return !result;
  }

  public activate(): void {
    this.onActivatePressed.emit(null);
  }

  public deactivate(): void {
    this.onDeactivatePressed.emit(null);
  }

  public isXLarge(): boolean {
    return this._isXLarge;
  }

  public isLarge(): boolean {
    return this._isLarge;
  }

  public isMedium(): boolean {
    return this._isMedium;
  }

  public isSmall(): boolean {
    return this._isSmall;
  }

  public isXSmall(): boolean {
    return this._isXSmall;
  }
}
